<template>
  <div class="passport-page" :style="{backgroundImage:'url('+ bg +')'}">
    <!--	<div class="common-head d-flex align-items-center">-->
    <!--		<img src="/assets/img/xml_logo.png" alt="">-->
    <!--		<span>{{title}}</span>-->
    <!--	</div>-->
    <div class="passport-logo-wrapper">
      <div class="fd-logo d-flex align-items-center" style="margin-right: 36px;">
        <img src="../../static/lasphub.png" alt="" width="100" height="100" style="margin-right: 16px;">
        <span style="font-weight: bold;font-size: 18px;" class="color-dark">LASP Software Platform</span>
      </div>
    </div>
    <div class="passport-card" style="height: 497px;">
      <div class="width-100 h-100">
        <router-view></router-view>
      </div>
    </div>
    <div class="passport-footer">
      <div>
        <a href="http://beian.miit.gov.cn/" style="color: #7D7F80" target="_blank">
          Copyright ©2022 lasp<span class="ml-lg">沪ICP备18016621号-1</span>
        </a>
      </div>
    </div>
    <!--	<layout-pro-footer class="ant-layout-footer alain-pro__footer"></layout-pro-footer>-->
  </div>
</template>

<script>
/**
  * @name  (组件名称)
  * @module 组件存放位置
  * @desc 组件描述
  * @author Jacke
  * @date
  * @param {Object} [title]    - 参数说明
  * @param {String} [columns] - 参数说明
  * @example 调用示例
  *  <></>
  */

export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      bg: require("@/assets/img/denglubeijing.jpg")
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {},
  computed: {},
}
</script>

<style lang="less">
// d-flex align-items-center justify-content-between
.passport-page {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  // background-image: url('/assets/img/denglubeijing.png');
  //background-image: url('http://webdoc.oaks.cn/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20210629111559.png');
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.passport-card {
  margin-right: 198px;
  width: 416px;
  //height: 497px;
  opacity: 1;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
  padding: 40px 43px;
}

.passport-card-wrapper {
  display: flex;
  flex-direction: column;
  //height: calc(100% - 80px);
  //height: 100%;
  position: relative;

  .passport-card-title {
    line-height: 44px;
    font-weight: 600;
    margin-bottom: 9px;
    font-size: 22px;
  }

  .passport-card-sub-title {
    line-height: 20px;
    margin-bottom: 66px;
  }

  .passport-card-form {
    input {
      height: 44px;
      padding-left: 21px;
    }
  }

  .passport-card-button-group {
    //margin-bottom: 58px;
  }

  .passport-card-button {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    button {
      width: 100%;
      height: 44px;
      line-height: 44px;
      border-radius: 44px;
    }
  }
}

.passport-logo-wrapper {
  position: absolute;
  left: 65px;
  top: 65px;

  .passport-logo {
    width: 50px;
    height: 54px;
    margin-right: 13px;
  }

  .passport-title {
    width: 127px;
    height: 27px;
  }
}

.passport-footer {
  position: absolute;
  left: 65px;
  bottom: 42px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/passport/passport.vue